

/**
 * 用来控制底部按钮BottomBtn的样式(几个按钮就用几, 比如一个按钮就用styleNo[1]也就是‘one’)
 */
var styleNo = ['zero', 'one', 'two', 'three', 'four', 'five']

export {
	styleNo
}
